<template>
  <div class="user-manage">
    <!-- tab切换 -->
    <div class="tab-top">
      <div class="switch-menu">
        <el-radio-group
          class="menu-name"
          v-for="(item, index) in menuList"
          :key="index"
          v-model="selectedTab"
          @change="toUrl(item.url)"
        >
          <el-radio-button :label="item.name"></el-radio-button>
        </el-radio-group>
      </div>
    </div>

    <div class="form-container">
      <div class="flex">
        <span class="title">姓名：</span>
        <el-input class="white" clearable v-model="form.username" placeholder="请输入姓名"></el-input>
        <el-button class="btn-blue" icon="el-icon-search" @click="searchList">搜索</el-button>
      </div>
      <div class="add-user" @click="openDrawer">
        <span class="add-rectangle"></span>
        <span>新增用户</span>
      </div>
    </div>

    <!-- 用户列表 -->
    <div class="table-container">
      <div class="table">
        <el-table :data="userList" style="width: 100%">
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="username" label="用户名"></el-table-column>
          <el-table-column prop="status" label="使用状态">
            <template slot-scope="scope">
              <div :class="`status${scope.row.status}`">{{ scope.row.statusVal }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                :disabled="scope.row.status===0"
                class="btn-text"
                type="text"
                @click="updateUser(scope.row)"
              >编辑</el-button>
              <el-button
                class="btn-text"
                type="text"
                @click="updateStatus(scope.row)"
              >
                {{scope.row.status===0?'启用':'禁用'}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 新增/编辑用户 -->
    <el-drawer
      :title="drawerTitle"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <el-form ref="userForm" :rules="userFormRules" :model="userForm">
        <div class="sub-title">基本信息</div>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="userForm.name" class="white" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="username">
          <el-input :disabled="drawerTitle === '编辑'" v-model="userForm.username" class="white" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="userForm.password" class="white" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <div class="sub-title">设置权限</div>
        <el-form-item label="管理范围" prop="warehouseIdList" v-if="drawer">
          <WarehouseProjectSelectMultiple :parentSelectWarehouseAndProject="userForm.parentSelectWarehouseAndProject" @getSelectWarehouseAndProject="getSelectWarehouseAndProject"></WarehouseProjectSelectMultiple>
        </el-form-item>
        <el-form-item label="角色权限" prop="roleId">
          <el-select
            class="white"
            v-model="userForm.roleId"
            placeholder="请选择项目"
            @change="changeRoleId"
          >
            <el-option
              v-for="item in groupList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button class="btn-blue" @click="openDialog">补充权限</el-button>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submitForm('userForm')">确定</el-button>
      </div>
    </el-drawer>

    <!-- 补充权限弹框 -->
    <el-dialog title="补充权限" top="10vh" :visible.sync="userDialog" width="440px">
      <UserAuthTree v-if="userDialog" :list="allAuthList" :selectUserAuth="userAuthList" @getSetTree="getSetTree"></UserAuthTree>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="confirmAuth">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UserManage from "models/user-manage";
const userManage = new UserManage();
import Role from '@/models/system/role.js'
import Auth from '@/models/common/auth.js'
import roleMixins from '@/common/mixins/role.js'
import userManageMixins from '@/common/mixins/user-manage.js'
import UserAuthTree from '@/components/base/tree/tree.vue'
import WarehouseProjectSelectMultiple from '@/components/base/select/warehouse-project-select-multiple.vue'
export default {
  mixins: [roleMixins, userManageMixins],
  inject: ['reload'],
  components: {
    UserAuthTree,
    WarehouseProjectSelectMultiple
  },
  data() {
    return {
      selectedTab: '用户管理',
      form: {
        username: ""
      },
      searchForm: {
        username: ""
      },
      userList: [],
      // 全部权限
      allAuthList: [],
      userAuthList: [],
      // 来自角色的权限
      roleAuthList: [],
      userDialog: false,
      userForm: {
        id: "",
        name: "",
        username: "",
        password: "",
        // 选择的仓库和项目
        parentSelectWarehouseAndProject: [],
        roleId: ''
      },
      userFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },

      drawer: false,
      drawerTitle: '新增',
    };
  },
  watch: {
    drawer: {
      handler(newVal) {
        if (!newVal) {
          this.userForm.id = "";
          this.userForm.name = "";
          this.userForm.username = "";
          this.userForm.password = "";
          this.userForm.roleId = "";
          this.userForm.parentSelectWarehouseAndProject = [];
          this.userAuthList = [];
          this.userFormRules.password[0].required = true;
        }
      }
    }
  },

  activated() {
    this.selectedTab = '用户管理'
  },
  created() {
    this.getUserList();
    this.initUserAllAuthList()
  },
  methods: {
    /** 
     * @desc 获取管理员列表
    */
    getUserList() {
      let name = this.searchForm.username;
      userManage.getManagerList(name).then(res => {
        if (res.success) {
          let userList = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.username = value.username;
            obj.status = value.status;
            obj.statusVal = value.status === 1 ? '已启用': '已禁用';
            userList.push(obj);
          });
          this.userList = userList;
        }
      });
    },

    /**
     * @desc 用户全部权限
     */
    initUserAllAuthList() {
      Auth.getUserAllAuthTree().then(res => {
        if (res.success) {
          this.allAuthList = res.result
        } else {
          this.$message.error(res.message);
        }
      })
    },
    
    /** 
     * @desc 获取详情信息
    */
    initDetails(id) {
      userManage.getUserManageDetails(id).then(res => {
        if (res.success) {
          let { bizRoleId, warehouseAndProjectResVoList } = res.result
          this.userForm.roleId = bizRoleId
          let arr = []
          warehouseAndProjectResVoList.map(i => {
            let obj = {}
            obj.id = i.warehouseId
            obj.name = i.warehouseName
            obj.checkAll = i.checkFlag == 1 ? true:false
            obj.isIndeterminate = i.checkFlag == 2 ? true:false
            obj.projectIdList = i.projectIdList
            arr.push(obj)
          })
          this.userForm.parentSelectWarehouseAndProject = arr
          this.drawer = true
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * @desc 用户拥有的权限（列表）
     */
    initUserAuthList(id) {
      userManage.getUserAuthList(id).then(res => {
        if (res.success) {
          let arr = []
          let roleAuthList = []
          res.result.map(i => {
            if (i.source === 1) {
              roleAuthList.push(i.keyword)
            }
            arr.push(i.id)
          })
          this.roleAuthList = roleAuthList
          this.userAuthList = arr
          this.allAuthList = this.restructureAllAuthList(this.allAuthList)
          this.restructureParentRoleIsDisabled(this.allAuthList)
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * @desc 获取角色权限列表
     */
    initRoleAuth() {
      let bizRoleId = this.userForm.roleId
      let data = {
        bizRoleId
      }
      Role.getRoleAuth(data).then(res => {
        if (res.success) {
          let arr = []
          let idList = []
          res.result.map(i => {
            arr.push(i.keyword)
            idList.push(i.id)
          })
          this.userAuthList = idList
          this.roleAuthList = arr
          this.allAuthList = this.restructureAllAuthList(this.allAuthList)
          this.restructureParentRoleIsDisabled(this.allAuthList)
        } else {
          this.$message.error(res.message);
        }
      })
    },

    searchList() {
      this.searchForm = this.form;
      this.getUserList();
    },

    changeRoleId() {
      this.userAuthList = []
      this.initRoleAuth()
    },

    /**
     * @desc 修改状态
     */
    updateStatus(row) {
      if (row.status == 1) {
        this.$confirm("关闭后，该用户账号将无法登录后台，请确认", "关闭", {
          confirmButtonText: "关闭",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-red',
          cancelButtonClass: 'btn-gray'
        }).then(() => {
          this.postUpdateStatus(row.id)
        });
      } else {
        this.$confirm("启用后，该用户账号变更为可登录后台状态，请确认", "启用", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-blue',
          cancelButtonClass: 'btn-gray'
        }).then(() => {
          this.postUpdateStatus(row.id)
        });
      }
    },

    /**
     * @desc 更新使用状态
     */
    postUpdateStatus(id) {
      let data = {
        id
      };
      userManage.postUpdateManagerStatus(data).then(res => {
        if (res.success) {
          this.getUserList();
        }
      });
    },

    openDrawer() {
      this.drawerTitle = '新增'
      this.allAuthList = this.restructureAllAuthList(this.allAuthList)
      this.drawer = true
    },

    handleCloseDrawer() {
      this.drawer = false
    },

    /**
     * @desc 显示补充权限弹窗
     */
    openDialog() {
      this.userDialog = true;
    },

    /** 
     * @desc 关闭补充权限弹窗
    */
    closeDialog() {
      this.userDialog = false;
    },

    confirmAuth() {
      this.closeDialog()
    },

    getSetTree(v) {
      let arr = []
      v.map(i => {
        arr.push(i.id)
      })
      this.userAuthList = arr
    },

    /**
     * @desc 编辑
     */
    updateUser(row) {
      this.userForm.id = row.id;
      this.userForm.name = row.name;
      this.userForm.username = row.username;
      this.userFormRules.password[0].required = false;
      this.drawerTitle = '编辑'
      this.initDetails(row.id)
      this.initUserAuthList(row.id)
    },

    /**
     * @desc 用户全部权限
     */
    restructureAllAuthList(list, v = []) {
      list.map(i => {
        if (this.roleAuthList.indexOf(i.keyword) !== -1) {
          i.disabled = true
        } else {
          i.disabled = false
        }
        v.push(i)
        if (i.children && i.children.length > 0) {
          this.restructureAllAuthList(i.children, v.children)
        }
      })
      return v
    },

    /**
     * @desc 根据某个父级点下的所有子节点的disabled,来修改父级的disable
     */
    restructureParentRoleIsDisabled(list, parentList = [], j = 0) {
      let isFlag = true
      list.map((i, index) => {
        if (!i.disabled) {
          isFlag = false
        }
        if (i.children && i.children.length > 0) {
          this.restructureParentRoleIsDisabled(i.children, list, index)
        }
      })
      if (isFlag) {
        parentList[j].disabled = true
      }
    },
    
    /**
     * @desc 获取已设置的仓库和项目
     */
    getSelectWarehouseAndProject(v) {
      this.userForm.parentSelectWarehouseAndProject = v
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let saveWarehouseAndProjectReqVoList = []
          this.userForm.parentSelectWarehouseAndProject.map(i => {
            let obj = {}
            obj.warehouseId = i.id
            obj.projectIdList = i.projectIdList
            saveWarehouseAndProjectReqVoList.push(obj)
          })
          if (this.userForm.id) {
            let data = {};
            data.id = this.userForm.id;
            data.name = this.userForm.name;
            data.username = this.userForm.username;
            data.password = this.userForm.password;
            data.bizRoleId = this.userForm.roleId;
            data.saveWarehouseAndProjectReqVoList = saveWarehouseAndProjectReqVoList;
            data.authorityIdList = this.userAuthList;
            userManage.postUpdateManager(data).then(res => {
              if (res.success) {
                this.getUserList();
                this.handleCloseDrawer();
                this.$message.success("编辑成功");
                this.reload()
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.name = this.userForm.name;
            data.username = this.userForm.username;
            data.password = this.userForm.password;
            data.bizRoleId = this.userForm.roleId;
            data.saveWarehouseAndProjectReqVoList = saveWarehouseAndProjectReqVoList;
            data.authorityIdList = this.userAuthList;
            userManage.postAddManager(data).then(res => {
              if (res.success) {
                this.getUserList();
                this.handleCloseDrawer();
                this.$message.success("新增成功");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
  }
};
</script>
<style lang="scss">
@import '@/assets/style/layout/system/user-manage.scss';
</style>
